import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

const Input = styled.input`
  width: 100%;
  max-width: 320px;
  padding: 10px 14px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 16px;
  line-height: 1.4;


`

const digits = s => s.replace(/\D/g, '')
const formatCpf = raw => {
  let d = digits(raw).slice(0, 11)
  if (d.length > 9)  d = d.replace(/(\d{3})(\d{3})(\d{3})(\d{0,2})/, '$1.$2.$3-$4')
  else if (d.length > 6) d = d.replace(/(\d{3})(\d{3})(\d{0,3})/, '$1.$2.$3')
  else if (d.length > 3) d = d.replace(/(\d{3})(\d{0,3})/, '$1.$2')
  return d
}
const formatPhone = raw => {
  const d = digits(raw).slice(0, 11)
  if (d.length > 6)  return d.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3').replace(/-$/, '')
  if (d.length > 2)  return d.replace(/(\d{2})(\d{0,5})/, '($1) $2')
  return d ? `(${d}` : ''
}

export default function NumberInput ({ value = '', format = 'free', onChange }) {
  const [text, setText] = useState('')

  useEffect(() => {
    switch (format) {
      case 'cpf':   setText(formatCpf(value));   break
      case 'phone': setText(formatPhone(value)); break
      default:      setText(digits(value))     
    }
  }, [value, format])

  const handleChange = e => {
    const raw = e.target.value
    let masked

    if (format === 'cpf')      masked = formatCpf(raw)
    else if (format === 'phone') masked = formatPhone(raw)
    else                        masked = digits(raw)   
    setText(masked)
    onChange(digits(masked))   
  }

  return (
    <Input
      type="text"
      inputMode="numeric"      
      pattern="[0-9]*"        
      value={text}
      placeholder={(function getPlaceholder() {
        switch (format) {
          case 'cpf': return 'CPF';
          case 'phone': return '(DD) 99999-9999';
          default: return 'Apenas números';
        }
      })()}
      onChange={handleChange}
    />
  )
}
